import { FC, PropsWithChildren } from "react"
import { Navigate, Outlet } from "react-router"
import { pathConstants } from "src/features/shared-module/constants"
import LoadingPage from "./LoadingPage"

type ProtectedRouteProps = {
  redirectPath?: string
  idpLoading: boolean
  isLoading: boolean
  isAuthenticated: boolean
}

export const ProtectedRoute: FC<PropsWithChildren<ProtectedRouteProps>> = ({
  redirectPath = `/${pathConstants.login}`,
  idpLoading,
  isLoading,
  isAuthenticated,
  children,
}) => {
  // const { isLoading, isAuthenticated } = useAuth0()
  // const { fetchMe, isLoading: idpLoading } = useMe()
  // useEffect(() => {
  //   if (isAuthenticated) {
  //     fetchMe()
  //   }
  // }, [fetchMe, isAuthenticated])

  if (isLoading || idpLoading) {
    return <LoadingPage />
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />
  }

  return children ? children : <Outlet />
}
